import { DATA_URL, debugMode } from '../model/StaticVariables';

/* Cross-Browser Import of XML document into a XML Document. */
function importXML(xmlfile, callback, arg1, arg2) {
    var xhr = new XMLHttpRequest();
    // xhr.callback = callback;
    xhr.open('GET', xmlfile, true);

    // If specified, responseType must be empty string or "document"
    xhr.responseType = 'document';

    // overrideMimeType() can be used to force the response to be parsed as XML
    xhr.overrideMimeType('text/xml');

    xhr.onload = function () {
        if (xhr.readyState === xhr.DONE) {
            if (xhr.status === 200) {
                // console.log(xhr.response);
                callback(xhr.responseXML, arg1, arg2);
            }
        }
    };

    xhr.send(null);
}

function loadpublicationsxml(category, groupName) {
    // Load the xml file
    var xmlpath = 'xmldata/SVIPublications.xml';
    var xmlDoc = importXML(xmlpath, createpublications, category, groupName);
    // Get all Elements with Tag name 'Publication'
}
function createpublications(xmlDoc, category, groupName) {
    var x = xmlDoc.getElementsByTagName('Publication');
    // Loop through Publication tag and process it for "publications" element
    for (let i = 0; i < x.length; i++) {
        // Create 'br' tag and then append it to publications element of the page
        var rowdiv = document.createElement('div');
        rowdiv.className = 'row';

        var spanDiv = document.createElement('div');

        var h2Elem = document.createElement('h4');

        h2Elem.innerText = x[i].getAttribute('Category');

        spanDiv.appendChild(h2Elem);

        // Get all Elements with Tag name 'Group' under current Publication tag
        var y = x[i].getElementsByTagName('Group');
        for (let j = 0; j < y.length; j++) {
            //If the Group's Name attribute is not empty, add a new Paragraph and put the Name text to the paragraph.
            //  if (y[j].getAttribute('Name') == groupName) {
            //9/7/18 uma each group is a panel

            var modDiv = document.createElement('div');
            modDiv.className = 'module-typeA tp-collapsible';
            //collapse 2nd panel onwards
            if (i != 0) modDiv.className += ' tp-collapsible-collapsed';

            var headerElem = document.createElement('h3');
            headerElem.className = 'tp-collapsible-header tp-collapsible-toggle tp-noselect';
            headerElem.innerHTML = y[j].getAttribute('Name');

            var img1 = document.createElement('img');
            img1.className = 'tp-collapsible-icon-expand';
            img1.alt = 'expand';
            img1.tabindex = '0';
            img1.src = '/TemplatePackage/3.0/images/plus12-reverse.png';
            var img2 = document.createElement('img');
            img2.className = 'tp-collapsible-icon-collapse';
            img2.alt = 'collapse';
            img2.tabindex = '0';
            img2.src = '/TemplatePackage/3.0/images/minus12-reverse.png';

            headerElem.appendChild(img1);
            headerElem.appendChild(img2);

            modDiv.appendChild(headerElem);

            var contentDiv = document.createElement('div');

            // Get all Elements with Tag name 'Item' under current Publication tag
            var z = y[j].getElementsByTagName('Item');
            // Loop through Item tag and process it for "publications" element
            for (let k = 0; k < z.length; k++) {
                var pElem = document.createElement('p');
                if (k == 0) {
                    pElem.className = 'tp-collapsible-content';
                }
                if (z[k].getElementsByTagName('Authors').length > 0) if (z[k].getElementsByTagName('Authors')[0].childNodes.length > 0) pElem.innerText = z[k].getElementsByTagName('Authors')[0].childNodes[0].nodeValue + ' ';
                //var bElem_z = document.createElement('a');

                //var spanbElem = document.createElement('span');
                //spanbElem.className = "cdc-decorated";

                var aElem = document.createElement('a');
                //  aElem.className = "tp-link-policy";
                if (z[k].getElementsByTagName('Link')[0].childNodes.length > 0) {
                    aElem.setAttribute('href', z[k].getElementsByTagName('Link')[0].childNodes[0].nodeValue);
                    aElem.setAttribute('target', '_blank');
                }
                var spanaElem = document.createElement('span');
                spanaElem.className = 'tp-label';
                //If the Title property of the item is empty, it will be a child item
                if (z[k].getElementsByTagName('Title')[0].childNodes.length > 0) {
                    spanaElem.innerHTML = z[k].getElementsByTagName('Title')[0].childNodes[0].nodeValue + '&#160;';
                } else {
                    spanaElem.innerHTML = '';
                }

                aElem.appendChild(spanaElem);

                if (z[k].getElementsByTagName('ImgAlt')[0].childNodes.length > 0) {
                    var spanimgElem = document.createElement('span');
                    spanimgElem.className = 'plugIns';

                    var imgElem = document.createElement('img');
                    imgElem.className = 'plugin';
                    imgElem.style.border = '0';
                    //if the ImgAlt is empty, it will be the Parent item
                    if (z[k].getElementsByTagName('ImgAlt')[0].childNodes.length > 0) {
                        imgElem.setAttribute('title', z[k].getElementsByTagName('ImgAlt')[0].childNodes[0].nodeValue);
                    }
                    //if the ImgAlt is empty, it will be the Parent item
                    if (z[k].getElementsByTagName('Icon')[0].childNodes.length > 0) {
                        imgElem.setAttribute('src', z[k].getElementsByTagName('Icon')[0].childNodes[0].nodeValue);
                    }
                    //if the ImgAlt is empty, it will be the Parent item
                    if (z[k].getElementsByTagName('ImgAlt')[0].childNodes.length > 0) {
                        imgElem.setAttribute('alt', z[k].getElementsByTagName('ImgAlt')[0].childNodes[0].nodeValue);
                    }

                    spanimgElem.appendChild(imgElem);
                    aElem.appendChild(spanimgElem);
                }

                pElem.appendChild(aElem);
                if (z[k].getElementsByTagName('LinkText').length > 0)
                    if (z[k].getElementsByTagName('LinkText')[0].childNodes.length > 0) {
                        var spnTxt = document.createElement('span');
                        spnTxt.innerHTML = '&#160;<em>' + z[k].getElementsByTagName('LinkText')[0].childNodes[0].nodeValue + '</em>';
                        pElem.appendChild(spnTxt);
                    }

                contentDiv.appendChild(pElem);
            }
            modDiv.appendChild(contentDiv);
            spanDiv.appendChild(modDiv);
            rowdiv.appendChild(spanDiv);

            document.getElementById('publications').appendChild(rowdiv);
        }
    }
    // CDC.Modules.init();
}

function loadcountiesxml() {
    if (document.getElementById('State').value == '') {
        document.getElementById('County').options.length = 0;
        var opt0 = document.createElement('option');
        opt0.value = '';
        opt0.text = ' -------- Select a state first --------';
        document.getElementById('County').options.add(opt0);
    } else {
        var year = document.getElementById('Year').value;

        var xmlpath = DATA_URL + '/list/' + year + '_counties.xml';
        importXML(xmlpath, populateCounties_PreparedMapDDL, null, null);
    }
}
export { loadcountiesxml };
function loadcountiesxml_fordownload() {
    if (document.getElementById('State').value == '') {
        document.getElementById('County').options.length = 0;
        var opt0 = document.createElement('option');
        opt0.value = '';
        opt0.text = ' ------ Select a geography first ------';
        document.getElementById('County').options.add(opt0);
    } else {
        var year = document.getElementById('Year').value;

        populateCountiesDDL(year);
    }
}
function reloadcountiesxml() {
    var year = document.getElementById('Year').value;

    //Enable/Disable the Puerti Rico option
    if (year == '2000' || year == '2010') {
        document.getElementById('State').options[40].disabled = true;
    } else {
        document.getElementById('State').options[40].disabled = false;
    }

    if (document.getElementById('State').value == '') {
        document.getElementById('County').options.length = 0;
        var opt0 = document.createElement('option');
        opt0.value = '';
        opt0.text = ' -------- Select a state first --------';
        document.getElementById('County').options.add(opt0);
    } else if (document.getElementById('State').value == 'Puerto Rico' && (year == '2000' || year == '2010')) {
        document.getElementById('State').value = '';
        document.getElementById('County').options.length = 0;
        var opt0 = document.createElement('option');
        opt0.value = '';
        opt0.text = ' -- Select a state first --';
        document.getElementById('County').options.add(opt0);
    } else {
        var xmlpath = DATA_URL + '/list/' + year + '_Counties.xml';
        importXML(xmlpath, populateCounties_PreparedMapDDL, null, null);
    }
}
export { reloadcountiesxml };
function populateCountiesDDL(year) {
    document.getElementById('County').options.length = 0;
    var geo = document.getElementById('State').value;
    geo = geo.replace(/\s+/g, '');
    if (year == 2000) {
        createOption();
    } else {
        document.getElementById('County').disabled = false;
        createUSOptions();
        if (document.getElementById('State').value != 'US') {
            if (year == 2010) {
                document.getElementById('County').options.length = 1;
                document.getElementById('County').value = 'Census Tracts';
                document.getElementById('County').disabled = true;
            }
            //else if (year == 2014) {
            else {
                //2016 now is as same as 2014
                //10/17/2018 if tribal tracts is selected, only census tracts is
                if (document.getElementById('State').value == 'TRIBAL_TRACTS') {
                    document.getElementById('County').options.length = 1;
                    document.getElementById('County').value = 'Census Tracts';
                    document.getElementById('County').disabled = true;
                }
            }
        }
    }

    resetFileTypeSelection(year, geo);
}
function populateCounties_PreparedMapDDL(xmlDoc, year) {
    var x = xmlDoc.getElementsByTagName('State');

    for (let i = 0; i < x.length; i++) {
        if (document.getElementById('State').value == x[i].getAttribute('name')) {
            var counties = x[i].getElementsByTagName('County');

            document.getElementById('County').options.length = 0;

            var opt1 = document.createElement('option');
            opt1.value = '';
            opt1.text = ' ----- Select your option -----';
            document.getElementById('County').options.add(opt1);

            for (var j = 0; j < counties.length; j++) {
                var opt = document.createElement('option');
                opt.value = counties[j].firstChild.nodeValue;
                opt.text = counties[j].firstChild.nodeValue;
                if (counties[j].hasAttribute('name')) opt.setAttribute('data-filename', counties[j].getAttribute('name'));
                document.getElementById('County').options.add(opt);
            }
            console.log('finished populating...');
            window.dispatchEvent(new Event('CountyPopulation'));
            break;
        }
    }
}
function createOption() {
    var opt1 = document.createElement('option');
    opt1.value = 'Census Tracts';
    opt1.text = 'Census Tracts';
    document.getElementById('County').options.add(opt1);
    document.getElementById('County').value = 'Census Tracts';
    document.getElementById('County').disabled = true;
}

function resetFileTypeSelection(year, geo) {
    var doctype = '';
    var options = document.getElementsByName('downloadtype');
    if (options) {
        for (var i = 0; i < options.length; i++) {
            if (options[i].checked) {
                doctype = options[i].value;
            }
        }
    }
    if (doctype === 'data' && (year === '2000' || year === '2010')) {
        if (geo === 'US') {
            document.getElementById('FileType').disabled = false;
        } else if (geo === 'State' || geo === 'States') {
            document.getElementById('FileType').value = 'shp'; //set default value
            document.getElementById('FileType').disabled = true;
        } else {
            //a state
            document.getElementById('FileType').value = 'csv'; //set default value
            document.getElementById('FileType').disabled = true;
        }
    }
}

function createUSOptions() {
    var optionsArr = ['Census Tracts', 'Counties'];

    for (var i = 0; i < optionsArr.length; i++) {
        var opt = document.createElement('option');
        opt.innerHTML = optionsArr[i];
        opt.value = optionsArr[i];
        document.getElementById('County').options.add(opt);
    }
}
function opencountymap() {
    if (document.getElementById('State').value == '') {
        alert('Please select a state first');
    } else if (document.getElementById('County').value == '') {
        alert('Please select a county first');
    } else {
        var mapsize = '';
        var fileName = '';
        if (document.getElementById('Year').value == '2014' || document.getElementById('Year').value == '2016' || document.getElementById('Year').value == '2018' || document.getElementById('Year').value == '2020' || document.getElementById('Year').value == '2022') {
            var selOption = document.getElementById('County').options[document.getElementById('County').selectedIndex];
            fileName = mapsize + document.getElementById('State').value.replace(/\s+/g, '') + document.getElementById('Year').value + '_' + (selOption.hasAttribute('data-filename') ? selOption.getAttribute('data-filename') + '.pdf' : document.getElementById('County').value + '.pdf');
            // fileName = mapsize + document.getElementById('State').value.replace(/\s+/g, '') +document.getElementById('Year').value + "_" + document.getElementById('County').value + ".pdf";
        } else if (document.getElementById('Year').value == '2010') {
            var selOption = document.getElementById('County').options[document.getElementById('County').selectedIndex];
            fileName = mapsize + document.getElementById('State').value + document.getElementById('Year').value + '_v2_' + (selOption.hasAttribute('data-filename') ? selOption.getAttribute('data-filename') + '.pdf' : document.getElementById('County').value + '.pdf');
        } else {
            fileName = mapsize + document.getElementById('State').value + document.getElementById('Year').value + '_' + document.getElementById('County').value + '.pdf';
        }
        var fileBase = `https://svi.cdc.gov/Documents/CountyMaps/`;
        if (debugMode) {
            var origin = window.location.origin + '';

            if (origin === 'https://grasp_internal_test.cdc.gov') {
                fileBase = `https://grasp_internal_test.cdc.gov/svi2021/Documents/CountyMaps/`;
            }
            if (origin === 'https://grasp_partner_test.cdc.gov') {
                fileBase = `https://grasp_partner_test.cdc.gov/svi/Documents/CountyMaps/`;
            }
        }
        var filePath = encodeURI(fileBase + document.getElementById('Year').value + '/' + document.getElementById('State').value + '/' + fileName);
        window.open(filePath, '_blank');
    }
}
export { opencountymap };

function downloadState2010GeoData() {
    var modifiedDate = '03242014';

    if (document.getElementById('State').value == '') {
        alert('Please select geography first');
    } else if (document.getElementById('State').value == 'All States') {
        var fileName = 'SVI2010_States_' + modifiedDate + '.zip';
        var filePath = 'https://svi.cdc.gov/Documents/2010_SVI_Data/' + fileName;
        window.open(filePath, '_blank');
    } else {
        var fileName = document.getElementById('State').value + '_' + modifiedDate + '.zip';
        var filePath = 'https://svi.cdc.gov/Documents/2010_SVI_Data/States/' + fileName;
        window.open(filePath, '_blank');
    }
}

function downloadStateShapefile(year) {
    if (document.getElementById('State').value == '') {
        alert('Please select geography first');
    } else {
        var optionValue = document.getElementById('State').value;
        optionValue = optionValue.replace(/\s+/g, '');
        var fileName = optionValue + '.zip';
        var filePath = 'https://svi.cdc.gov/Documents/' + year + '_SVI_Data/States/' + fileName;
        window.open(filePath, '_blank');
    }
}

function downloadStateCSV(year) {
    if (document.getElementById('State').value == '') {
        alert('Please select geography first');
    } else {
        var optionValue = document.getElementById('State').value;
        optionValue = optionValue.replace(/\s+/g, '');
        var fileName = optionValue + '.csv';
        var filePath = 'https://svi.cdc.gov/Documents/' + year + '_SVI_Data/CSV/States/' + fileName;
        window.open(filePath, '_blank');
    }
}

function downloadCountyShapefile(year) {
    var cntyLabel = year == 2014 ? '_CNTY' : '_COUNTY';
    if (document.getElementById('County').value == '') {
        alert('Please select geography first');
    } else {
        var optionValue = document.getElementById('State').value;
        optionValue = optionValue.replace(/\s+/g, '');
        var fileName = optionValue + cntyLabel + '.zip';
        var filePath = 'https://svi.cdc.gov/Documents/' + year + '_SVI_Data/States_Counties/' + fileName;
        window.open(filePath, '_blank');
    }
}

function downloadCountyCSV(year) {
    var cntyLabel = year == 2014 ? '_CNTY' : '_COUNTY';
    if (document.getElementById('County').value == '') {
        alert('Please select State first');
    } else {
        var optionValue = document.getElementById('State').value;
        optionValue = optionValue.replace(/\s+/g, '');
        var fileName = optionValue + cntyLabel + '.csv';
        var filePath = 'https://svi.cdc.gov/Documents/' + year + '_SVI_Data/CSV/States_Counties/' + fileName;
        window.open(filePath, '_blank');
    }
}

function validate() {
    if (document.zipcodesviMapping.txtzipcode.value == '') {
        document.zipcodesviMapping.txtzipcode.focus();
        var alertempty = document.getElementById('zipcode');
        alertempty.style.visibility = 'visible';
        var alertwrongformat = document.getElementById('CustomValidator1');
        alertwrongformat.style.visibility = 'hidden';
        return false;
    }
    if (isNaN(document.zipcodesviMapping.txtzipcode.value) || document.zipcodesviMapping.txtzipcode.value.length != 5) {
        document.zipcodesviMapping.txtzipcode.focus();
        var alertempty = document.getElementById('zipcode');
        alertempty.style.visibility = 'hidden';
        var alertwrongformat = document.getElementById('CustomValidator1');
        alertwrongformat.style.visibility = 'visible';
        return false;
    }

    var alertempty = document.getElementById('zipcode');
    alertempty.style.visibility = 'hidden';
    var alertwrongformat = document.getElementById('CustomValidator1');
    alertwrongformat.style.visibility = 'hidden';
    return true;
}

//uma's code
function loadstatesxml_fordownload() {
    var year = document.getElementById('Year').value;
    const pathAdjust = DATA_URL + '/';
    var xmlpath = pathAdjust + 'data/list/SVI_StatesForDownload.xml';
    importXML(xmlpath, populateStatesDDL, year, null);
}
function downloadData() {
    var year = document.getElementById('Year').value;
    var docType = document.querySelector('input[name="downloadtype"]:checked').value;
    if (docType == 'doc') downloadDocumentation(year);
    else {
        if (document.getElementById('State').value == 'NA') {
            alert('Please select geography first');
        } else {
            var geo = document.getElementById('State').value;
            geo = geo.replace(/\s+/g, '');
            var fileName, filePath;
            if (year == 2000) download2000Data(geo);
            else if (year == 2010) download2010Data(geo);
            else {
                if (geo == 'US') {
                    if (year == 2016 || year == 2018) downloadUSData('COUNTY', '', year);
                    else if (year == 2014)
                        //downloadUSData('CNTY', '03242014',year);
                        downloadUSData('CNTY', '', year);
                } else {
                    var county = document.getElementById('County').value;
                    if (county.replace(/\s+/g, '') == 'Counties') downloadCountyData(year);
                    else downloadStateData(year);
                }
            }
        }
    }
}

function downloadUSData(cntyLabel, usLabel, year) {
    var fileName, filePath;
    var docType = document.getElementById('FileType').value;
    docType = docType.replace(/\s+/g, '');
    var geoType = document.getElementById('County').value.replace(/\s+/g, '');
    var label = usLabel != '' ? '_' + usLabel : '';
    if (geoType == 'CensusTracts') {
        if (docType == 'shp') {
            fileName = 'SVI' + year + '_US' + label + '.zip';
            filePath = 'https://svi.cdc.gov/Documents/' + year + '_SVI_Data/' + fileName;
        } else if (docType == 'csv') {
            fileName = 'SVI' + year + '_US.csv';
            filePath = 'https://svi.cdc.gov/Documents/' + year + '_SVI_Data/CSV/' + fileName;
        }

        window.open(filePath, '_blank');
    } else if (geoType == 'Counties') {
        if (docType == 'shp') {
            fileName = 'SVI' + year + '_US_' + cntyLabel + '.zip';
            filePath = 'https://svi.cdc.gov/Documents/' + year + '_SVI_Data/' + fileName;
        } else if (docType == 'csv') {
            fileName = 'SVI' + year + '_US_' + cntyLabel + '.csv';
            filePath = 'https://svi.cdc.gov/Documents/' + year + '_SVI_Data/CSV/' + fileName;
        }

        window.open(filePath, '_blank');
    }
}
function populateStatesDDL(xmlDoc, year) {
    var doctype;
    var options = document.getElementsByName('downloadtype');
    if (options) {
        for (var i = 0; i < options.length; i++) {
            if (options[i].checked) {
                doctype = options[i].value;
            }
        }
    }
    if (doctype == 'data') {
        //clear state select options
        document.getElementById('State').options.length = 0;
        var x = xmlDoc.getElementsByTagName('Data');

        for (let i = 0; i < x.length; i++) {
            var states = x[i].getElementsByTagName('State');
            var opt1 = document.createElement('option');
            opt1.value = 'NA';
            opt1.text = ' ----- Select your option -----';
            document.getElementById('State').options.add(opt1);

            for (var j = 0; j < states.length; j++) {
                var opt = document.createElement('option');
                opt.value = states[j].getAttribute('value');
                opt.text = states[j].firstChild.nodeValue;
                if (j == 1 || j == 3)
                    //1 and 3 are dash lines
                    opt.disabled = true; //Disbale them
                document.getElementById('State').options.add(opt);
            }
            if (year == 2000) {
                //document.getElementById("State").options.length = 2; //get the postion of the 2nd option, which is Puerto Rico
                var opt = document.createElement('option');
                opt.value = 'State';
                opt.text = 'State-specific';
                document.getElementById('State').options.add(opt, 5); //Insert State-specific to the position at index is 5
            } else if (year == 2010) {
                var opt = document.createElement('option');
                opt.value = 'States';
                opt.text = 'All States';
                document.getElementById('State').options.add(opt, 5); //Insert All States to the position at index is 5
            }
            //else if (year == 2014) {
            else {
                //2014 and 2016
                var options = document.getElementById('State').options;
                var index = 48; //Texas just in case
                for (let k = 0; k < options.length; k++) {
                    if (options[k].value === 'Texas') {
                        index = k; //Find Texas postion
                        break;
                    }
                }
                var opt = document.createElement('option');
                opt.value = 'TRIBAL_TRACTS';
                opt.text = 'Tribal Tracts';
                document.getElementById('State').options.add(opt, index + 1); //Insert Tribal Tracts after Texas
            }
        }
        var xmlpath;
        populateCountiesDDL(year);
        document.getElementById('FileType').disabled = false;
        if (year == 2000) {
            document.getElementById('State').options[3].disabled = true; //PR

            document.getElementById('FileType').options[0].innerText = 'ESRI Geodatabase';
            document.getElementById('FileType').options[1].disabled = false; //csv disabled
            document.getElementById('FileType').value = 'shp'; //set default value
        } else if (year == 2010) {
            document.getElementById('County').disabled = false; //Geography Type
            document.getElementById('State').options[3].disabled = true; //PR

            document.getElementById('FileType').options[0].innerText = 'ESRI Geodatabase';
            document.getElementById('FileType').options[1].disabled = false;
            document.getElementById('FileType').value = 'shp'; //set default value
        } else {
            document.getElementById('State').disabled = false;
            document.getElementById('State').options[3].disabled = false; //PR
            document.getElementById('FileType').options[0].innerText = 'Shapefile';
            document.getElementById('FileType').options[1].disabled = false; //csv disabled
        }
    }
}
function downloadStateData(year) {
    var docType = document.getElementById('FileType').value;
    docType = docType.replace(/\s+/g, '');
    if (docType == 'shp') downloadStateShapefile(year);
    else if (docType == 'csv') downloadStateCSV(year);
    else if (docType == 'pdf') window.open('https://svi.cdc.gov/Documents/' + year + '_SVI_Data/' + 'SVI' + year + 'Documentation.pdf', '_blank');
}
function downloadCountyData(year) {
    var docType = document.getElementById('FileType').value;
    docType = docType.replace(/\s+/g, '');
    if (docType == 'shp') downloadCountyShapefile(year);
    else if (docType == 'csv') downloadCountyCSV(year);
    else if (docType == 'pdf') window.open('https://svi.cdc.gov/Documents/' + year + '_SVI_Data/' + 'SVI' + year + 'Documentation.pdf', '_blank');
}
function download2000Data(geo) {
    var fileName, filePath;
    var fileType = document.getElementById('FileType').value;
    fileType = fileType.replace(/\s+/g, '');
    if (fileType == 'shp') {
        fileName = geo + '_2000_SVI.zip';
        filePath = 'https://svi.cdc.gov/Documents/2000_SVI_Data/' + fileName;
        window.open(filePath, '_blank');
    } else if (fileType == 'csv') {
        if (geo == 'US') {
            fileName = 'SVI2000_US.csv';
            filePath = 'https://svi.cdc.gov/Documents/2000_SVI_Data/CSV/' + fileName;
        } else {
            var optionValue = document.getElementById('State').value;
            optionValue = optionValue.replace(/\s+/g, '');
            fileName = optionValue + '.csv';
            filePath = 'https://svi.cdc.gov/Documents/2000_SVI_Data/CSV/States/' + fileName;
        }

        window.open(filePath, '_blank');
    } else if (fileType == 'pdf') {
        window.open('https://svi.cdc.gov/Documents/2000_SVI_Data/SVI2000DataDictionary.pdf', '_blank');
    }
}
function download2010Data(geo) {
    var fileType = document.getElementById('FileType').value;
    fileType = fileType.replace(/\s+/g, '');
    var fileName, filePath;
    if (fileType == 'shp') {
        if (geo == 'US') {
            var cntyOpt = document.getElementById('County').value;
            cntyOpt = cntyOpt.replace(/\s+/g, '');
            if (cntyOpt == 'CensusTracts') filePath = 'https://svi.cdc.gov/Documents/2010_SVI_Data/SVI2010_US_03242014.zip';
            else if (cntyOpt == 'Counties') filePath = 'https://svi.cdc.gov/Documents/2010_SVI_Data/SVI2010_Counties.zip';
            window.open(filePath, '_blank');
        } else if (geo == 'States') {
            window.open('https://svi.cdc.gov/Documents/2010_SVI_Data/SVI2010_States_03242014.zip', '_blank');
        } else downloadState2010GeoData();
    } else if (fileType == 'csv') {
        if (geo == 'US') {
            fileName = 'SVI2010_US.csv';
            filePath = 'https://svi.cdc.gov/Documents/2010_SVI_Data/CSV/' + fileName;
        } else {
            var optionValue = document.getElementById('State').value;
            optionValue = optionValue.replace(/\s+/g, '');
            fileName = optionValue + '.csv';
            filePath = 'https://svi.cdc.gov/Documents/2010_SVI_Data/CSV/States/' + fileName;
        }

        window.open(filePath, '_blank');
    }
}
function radioClicked() {
    var doctype;
    var options = document.getElementsByName('downloadtype');
    if (options) {
        for (var i = 0; i < options.length; i++) {
            if (options[i].checked) {
                doctype = options[i].value;
            }
        }
    }
    if (doctype == 'doc') {
        addRemoveDocType(true);
        //  if (document.getElementById("datapanel") != undefined)
        document.getElementById('datapanel').style.display = 'none';
        //document.getElementById('FileType').options.length = 1;
        document.getElementById('FileType').value = 'pdf';
        document.getElementById('FileType').disabled = true;
    } else {
        loadstatesxml_fordownload();
        addRemoveDocType(false);
        document.getElementById('datapanel').style.display = 'block';
        //document.getElementById('FileType').options.length = 3;
        document.getElementById('FileType').value = 'shp';
        document.getElementById('FileType').disabled = false;
    }
}

// Added on 14Sept2020, Kiran Batchu
function loadDataDownloads() {
    loadstatesxml_fordownload();
    addRemoveDocType(false);
    document.getElementById('datapanel').style.display = 'block';
    //document.getElementById('FileType').options.length = 3;
    document.getElementById('FileType').value = 'shp';
    document.getElementById('FileType').disabled = false;
}

function addRemoveDocType(doAdd) {
    var optExists = false;
    if (doAdd) {
        for (let i = 0; i < document.getElementById('FileType').length; ++i) {
            if (document.getElementById('FileType').options[i].value == 'pdf') {
                optExists = true;
            }
        }
        if (!optExists) {
            var opt1 = document.createElement('option');
            opt1.value = 'pdf';
            opt1.text = ' PDF';
            document.getElementById('FileType').options.add(opt1, 0);
        }
    } else document.getElementById('FileType').remove(0);
}
function downloadDocumentation(year) {
    var fileName = 'SVI' + year + 'Documentation-508.pdf'; // KB,17Jul2020
    var filePath = 'https://svi.cdc.gov/Documents/' + year + '_SVI_Data/' + fileName;
    window.open(filePath, '_blank');
}
function geotypeChanged() {
    var year = document.getElementById('Year').value;
    //if (year == 2014) {
    if (year == 2014 || year == 2016 || year == 2018) {
        var options = document.getElementById('State').options;
        var ttindex = 49; //TRIBAL_TRACTS just in case
        for (var i = 0; i < options.length; i++) {
            if (options[i].value === 'TRIBAL_TRACTS') {
                ttindex = i;
                break;
            }
        }
        if (document.getElementById('County').value == 'Counties') document.getElementById('State').options[ttindex].disabled = true;
        else document.getElementById('State').options[ttindex].disabled = false;
    } else if (year == 2010) {
        if (document.getElementById('County').value == 'Counties') {
            document.getElementById('FileType').value = 'shp'; //set default value
            document.getElementById('FileType').disabled = true;
        } else {
            document.getElementById('FileType').disabled = false;
        }
    }
}
